import { Button } from '@progress/kendo-react-buttons';
import * as React from 'react';

export const Header = () => {

  return (
    <header
      className="header"
      style={{
        zIndex: 100,
        boxShadow: '0 10px 10px -10px rgb(0 0 0)',
        backgroundColor: process.env.REACT_APP_COLOR,
        height: '50px',
        width: '225px',
        position: 'fixed',
      }}>
      <div className="nav-container">
        <div className="title">
          <h1 style={{ fontSize: '1.25rem', paddingRight: '0px' }}>TANGUAY</h1>
        </div>
        {process.env.REACT_APP_ENV === 'dev' && (<Button
          style={{
            margin: '37px',
            paddingLeft: '10px',
            paddingRight: '10px',
            borderRadius: '100px',
            backgroundColor: 'black',
            color: 'white',
            fontWeight: 'bold',
            fontSize: '10px',
            borderStyle: 'none',
            opacity: '1'
          }} disabled>
          {process.env.REACT_APP_ENV.toUpperCase()}
        </Button>)}
      </div>
    </header>
  );
};

Header.displayName = 'Header';
